import CustomDropDownList, { IDropDownListItem } from "ui/dropDown";
import { FC } from "react";
import { ListItemProps } from "@progress/kendo-react-dropdowns";
import { DropDownItem } from "interface/common";
import React from "react";

export const SpecieDropdown: FC<IDropDownListItem> = ({
	dataItemKey = "code",
	textField = "displayName",
	...props
}) => {
	return (
		<CustomDropDownList
			dataItemKey={dataItemKey}
			textField={textField}
			{...props}
		/>
	);
};

export const DropdownRenderItem = (
	li: React.ReactElement<HTMLLIElement>,
	itemProps: ListItemProps
) => {
	const data: DropDownItem = itemProps.dataItem;

	const item = <div style={{ padding: "4px" }}>{data.displayName}</div>;

	return React.cloneElement(li, li.props, item);
};
